// extracted by mini-css-extract-plugin
export default {"wrapper":"sz-z","viewport":"tz-z","container":"uz-z","slide":"vz-z"};